@if (isVisible) {
<section outline>
  <h2>Assignment progress</h2>
  @if (hasStarted) {
  <div>
    <p>{{ progress }}% way through assignment</p>
    <small>Will end <relative-time [iso]="endDate"></relative-time>.</small>
  </div>
  } @if (!hasStarted) {
  <div>
    <p>Assignment not started yet</p>
    <small>
      Will start in <relative-time [iso]="startDate"></relative-time>.
    </small>
  </div>
  }
</section>
}
